import { TextField, TextFieldProps } from "@mui/material";
import React from "react";
import styles from "./CustomTextField.module.css";

type CustomTextFieldSize = "sm" | "md";

interface CustomTextFieldProps extends Omit<TextFieldProps, "size"> {
	size?: CustomTextFieldSize;
}

const CustomTextField = React.forwardRef<HTMLDivElement, CustomTextFieldProps>(
	(
		{
			autoComplete = undefined,
			autoFocus = false,
			className = "",
			color = "primary",
			defaultValue = undefined,
			disabled = false,
			error = false,
			fullWidth = false,
			helperText = undefined,
			id = undefined,
			label = undefined,
			multiline = false,
			name = undefined,
			onBlur = undefined,
			onChange = undefined,
			onFocus = undefined,
			placeholder = undefined,
			required = false,
			rows = 1,
			select = false,
			size = "md",
			type = "text",
			value = undefined,
			variant = "outlined",
			...rest
		},
		ref
	) => (
		<>
			{label && <div className={styles.textfield__label}>{label}</div>}
			<TextField
				ref={ref}
				autoComplete={autoComplete}
				autoFocus={autoFocus}
				className={`${styles.textfield} ${className}`}
				color={color}
				data-multiline={multiline}
				data-size={size}
				defaultValue={defaultValue}
				disabled={disabled}
				error={error}
				fullWidth={fullWidth}
				helperText={helperText}
				id={id}
				multiline={multiline}
				name={name}
				placeholder={placeholder}
				required={required}
				rows={rows}
				select={select}
				type={type}
				value={value}
				variant={variant}
				onBlur={onBlur}
				onChange={onChange}
				onFocus={onFocus}
				{...rest}
			/>
		</>
	)
);

export default CustomTextField;
